import React, { useState } from "react"

import * as S from "./style"

const Toggle = ({ title, body, isOn = false, disabled, onChange, styling }) => {
  const [on, setOn] = useState(isOn)

  const handleChange = () => {
    if (disabled) return

    const newState = !on
    setOn(newState)
    onChange(newState)
  }

  return (
    <S.ToggleInput onClick={handleChange} $disabled={disabled}>
      <S.Toggle $isOn={on} $onColour={styling.track.onColour} $offColour={styling.track.offColour}>
        <S.Pin $isOn={on} $onColour={styling.pin.onColour} $offColour={styling.pin.offColour} />
      </S.Toggle>
      <S.Text>
        <S.Title $colour={styling.labelColour}>{title}</S.Title>
        <S.Body $colour={styling.descriptionColour}>{body}</S.Body>
      </S.Text>
    </S.ToggleInput>
  )
}

export default Toggle
